import type { Menu } from "../Dropdown.vue";
import Ethereum from "@/assets/ethereum.webp";
import Bitcoin from "@/assets/bitcoin.webp";
import Dogecoin from "@/assets/dogecoin.webp";
import Itau from "@/assets/logo-itau.svg";
import Bb from "@/assets/logo-bb.svg";
import Petrobras from "@/assets/logo-petrobras.svg";
import Coin from "@/assets/coin.webp";

export const DropdownDto: Menu[] = [
	{
		titleRepresentation: {
			type: "image",
			value: Coin,
		},
		title: "Criptomoedas",
		link: "/cryptos",
		subContent: [
			{
				title: "Bitcoin",
				link: "/cryptos/bitcoin",
				logo: Bitcoin,
			},
			{
				title: "Ethereum",
				link: "/cryptos/ethereum",
				logo: Ethereum,
			},
			{
				title: "Dogecoin",
				link: "/cryptos/dogecoin",
				logo: Dogecoin,
			},
		],
	},
	{
		titleRepresentation: {
			type: "emoji",
			value: "&#128188;",
		},
		title: "Bolsa de Valores",
		link: "/stocks",
		subContent: [
			{
				title: "Petrobras",
				link: "/stocks/PETR3",
				logo: Petrobras,
			},
			{
				title: "Itaú",
				link: "/stocks/ITUB4",
				logo: Itau,
			},
			{
				title: "Banco do Brasil",
				link: "/stocks/BBAS3",
				logo: Bb,
			},
		],
	},
    	{
		titleRepresentation: {
			type: "emoji",
			value: "&#128444;&#65039;",
		},
		title: "NFTs",
		link: "/nfts",
		subContent: [
			{
				title: "Pudgy Penguins",
				link: "/nfts/pudgy-penguins",
				logo: "https://coin-images.coingecko.com/nft_contracts/images/38/small/pudgy.jpg?1730778323",
			},
			{
				title: "Bored Ape Yacht Club",
				link: "/nfts/bored-ape-yacht-club",
				logo: "https://coin-images.coingecko.com/nft_contracts/images/20/small/bored-ape-yacht-club.png?1707287177",
			},
			{
				title: "CryptoPunks",
				link: "/nfts/cryptopunks",
				logo: "https://coin-images.coingecko.com/nft_contracts/images/270/small/cryptopunks.png?1707287245",
			},
		],
	},
	{
		titleRepresentation: {
			type: "emoji",
			value: "&#127891;",
		},
		title: "Academia NEI",
		link: "/education",
		subContent: [
			{
				title: "Artigos Educacionais",
				link: "/education/articles",
				logo: "/logo-just-icon.webp",
			},
			{
				title: "Guias Práticos",
				link: "/education/guides",
				logo: "/logo-just-icon.webp",
			},
			{
				title: "Glossário Financeiro",
				link: "/education/glossary",
				logo: "/logo-just-icon.webp",
			},
		],
	},
	{
		titleRepresentation: {
			type: "emoji",
			value: "&#128293;",
		},
		title: "Mapas de Calor",
		link: "/heatmaps",
	},
	{
		titleRepresentation: {
			type: "emoji",
			value: "&#128197;",
		},
		title: "Calendário Econômico",
		link: "/calendar",
	},
];
